module.exports = __webpack_public_path__ + "static/media/Marvel-Login-Header.747c855e.jpg";